var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.8505 2.90103C14.2338 1.28436 12.6505 1.24269 10.9921 2.90103L9.9838 3.90936C9.90047 3.99269 9.86714 4.12603 9.90047 4.24269C10.5338 6.45103 12.3005 8.21769 14.5088 8.85103C14.5421 8.85936 14.5755 8.86769 14.6088 8.86769C14.7005 8.86769 14.7838 8.83436 14.8505 8.76769L15.8505 7.75936C16.6755 6.94269 17.0755 6.15103 17.0755 5.35103C17.0838 4.52603 16.6838 3.72603 15.8505 2.90103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0087 9.60573C12.767 9.48906 12.5337 9.3724 12.3087 9.23906C12.1253 9.13073 11.9503 9.01406 11.7753 8.88906C11.6337 8.7974 11.467 8.66406 11.3087 8.53073C11.292 8.5224 11.2337 8.4724 11.167 8.40573C10.892 8.1724 10.5837 7.8724 10.3087 7.53906C10.2837 7.5224 10.242 7.46406 10.1837 7.38906C10.1003 7.28906 9.95868 7.1224 9.83368 6.93073C9.73368 6.80573 9.61701 6.6224 9.50868 6.43906C9.37535 6.21406 9.25868 5.98906 9.14201 5.75573C9.02535 5.50573 8.93368 5.26406 8.85035 5.03906L3.61701 10.2724C3.50868 10.3807 3.40868 10.5891 3.38368 10.7307L2.93368 13.9224C2.85035 14.4891 3.00868 15.0224 3.35868 15.3807C3.65868 15.6724 4.07535 15.8307 4.52535 15.8307C4.62535 15.8307 4.72535 15.8224 4.82535 15.8057L8.02535 15.3557C8.17535 15.3307 8.38368 15.2307 8.48368 15.1224L13.717 9.88906C13.4837 9.80573 13.2587 9.71406 13.0087 9.60573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.93962d9683ef34595fed9d9160ee4037.svg";
export { ForwardRef as ReactComponent };